/* eslint-disable */
export default {
  noResultFoundFor: 'No result found for',
  foundFromServerHint: 'Type keyword and press Enter to search in {appName}',
  notResultFoundFromServer: 'No results found',
  loading: 'loading...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
